function toSuggestion(feature) {
  const props = feature?.properties || {};
  const coords = feature?.geometry?.coordinates || [];
  const name = props.name || props.city || props.county || props.state || '';
  const state = props.state || props.county || '';
  const country = props.country || '';
  const label = [name, state, country].filter(Boolean).join(', ');

  return {
    id: String(props.osm_id || props.place_id || label || Math.random()),
    name,
    state,
    country,
    label,
    lat: Number(coords[1]),
    lng: Number(coords[0]),
  };
}

const COUNTRY_CODE_ALIASES = {
  india: 'in',
  ind: 'in',
  bharat: 'in',
  'united arab emirates': 'ae',
  uae: 'ae',
  emirates: 'ae',
  'saudi arabia': 'sa',
  ksa: 'sa',
  bahrain: 'bh',
  jordan: 'jo',
};

function normalizePhotonCountryCode(input) {
  const value = String(input || '')
    .trim()
    .toLowerCase();
  if (!value) return '';
  if (/^[a-z]{2}$/.test(value)) return value;
  return COUNTRY_CODE_ALIASES[value] || '';
}

/**
 * Photon/OpenStreetMap location autocomplete.
 * @param {{ query: string, country?: string, countryCode?: string }} input
 */
export async function searchLocations({ query, country, countryCode }) {
  const q = String(query || '').trim();
  if (!q) return [];

  const params = new URLSearchParams({
    q,
    limit: '8',
    lang: 'en',
  });
  // Photon API expects `countrycode` (not `country`).
  const resolvedCountryCode = normalizePhotonCountryCode(countryCode || country);
  if (resolvedCountryCode) params.set('countrycode', resolvedCountryCode);

  const resp = await fetch(`https://photon.komoot.io/api/?${params.toString()}`, {
    method: 'GET',
  });

  if (!resp.ok) return [];

  const payload = await resp.json();
  const features = Array.isArray(payload?.features) ? payload.features : [];
  return features
    .map(toSuggestion)
    .filter((s) => s.name && Number.isFinite(s.lat) && Number.isFinite(s.lng));
}
